import { action } from "../common/Action"
import { ReportsClient } from "../generated";

const service = new ReportsClient();

class ReportsActions {

    @action
    async getCustomersByYear() {
        return (await service.getCustomersByYearReport())!;
    };

    @action
    async getCustomersByLocalityReport() {
        return (await service.getCustomersByLocalityReport())!;
    };

    @action
    async getImpiantiByYearsReport() {
        return (await service.getImpiantiByYearReport())!;
    };

    @action
    async getTopCaldaieReport() {
        return (await service.getImpiantiByModelloReport())!;
    };

    @action
    async getTopImpiantiClima() {
        return (await service.getTopImpiantiClima())!;
    };

    @action
    async getPlantForReplacementsCampaign(minYears: number) {
        const report = (await service.getPlantForReplacementsCampaign(minYears))!;
        return { minYears, report };
    };

}
export default new ReportsActions();